import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  getRelatorioAdvances,
  getRelatorioBilling,
  getRelatorioContractorInvoices,
  getRelatorioTimesheet,
} from './api';
import type {
  AdvancesDto,
  AdvancesQuery,
  BillingDto,
  BillingQuery,
  ContractorInvoicesDto,
  ContractorInvoicesQuery,
  TimesheetDto,
  TimesheetQuery,
} from './types';

/**
 * Relatórios são `useMutation`, não `useQuery` — usuário aperta "Gerar"
 * com filtros, recebe um snapshot pra renderizar e exportar. Sem cache
 * automático nem refetch on focus.
 */

export function useGerarTimesheet(): UseMutationResult<TimesheetDto, Error, TimesheetQuery> {
  return useMutation({ mutationFn: getRelatorioTimesheet });
}

export function useGerarBilling(): UseMutationResult<BillingDto, Error, BillingQuery> {
  return useMutation({ mutationFn: getRelatorioBilling });
}

export function useGerarContractorInvoices(): UseMutationResult<
  ContractorInvoicesDto,
  Error,
  ContractorInvoicesQuery
> {
  return useMutation({ mutationFn: getRelatorioContractorInvoices });
}

export function useGerarAdvances(): UseMutationResult<AdvancesDto, Error, AdvancesQuery> {
  return useMutation({ mutationFn: getRelatorioAdvances });
}
